import { Component } from '@angular/core';

@Component({
  selector: 'app-media-object-thumbnail',
  template: `
    <ng-content></ng-content>
  `,
})
export class MediaObjectThumbnailComponent {}
